import React, { useContext, useEffect, useMemo, useState } from "react";
import "ol/ol.css"; //스타일
import { Feature, Map as OlMap, View } from "ol"; //뷰 관리
import { fromLonLat, get as getProjection } from "ol/proj"; //위경도
import { Vector, XYZ } from "ol/source"; //지도정보
import { Tile as TileLayer } from "ol/layer";
import WKT from "ol/format/WKT";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import VectorLayer from "ol/layer/Vector";
import CircleStyle from "ol/style/Circle";
import pinsvg from "./pin.svg";
import { Point } from "ol/geom";
import Fill from "ol/style/Fill";
import grade from "ol/style/Stroke";

import { Button, ButtonGroup } from "@mui/material";
import DataContext from "../../../context/users/DataContextCopy";

// export const appkey = "F29065AD-8D42-3A88-8D7F-4DADA8D2E838";
// export const bems_inc_Url = "http://43.200.45.232:3196"; //bems 배포용
export const bems_inc_Url = ""; //폐쇄망 배포용
// export const bems_inc_Url = "http://152.99.41.90:2080"; //폐쇄망(운영서버)
// export const bems_inc_Url = "https://odor.incheon.go.kr/"; //실제 주소
export const enShowMap = {
  ShowBase: 1,
  ShowStellite: 2,
};
let tileLayer = new TileLayer({
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/base/{z}/{y}/{x}.png`,
  }),
});

let hybridLayer = new TileLayer({
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/Hybrid/{z}/{y}/{x}.png`,
  }),
});
function AsconMap(props) {
  const { onMapPointClick } = props;
  const { icOutBound, asconLastData } = useContext(DataContext);

  const [mapObject, setMapObject] = useState(null);
  const [mapType, setMapType] = useState("base");
  const onClick = (value) => {
    // console.log(value);
    setMapType(value);
    UpdateMapType(value);
  };

  // 항공지도(jpeg) 띄우기
  const UpdateMapType = (value) => {
    if (value === "base") {
      tileLayer
        .getSource()
        .setUrl(`${bems_inc_Url}/tiles/base/{z}/{y}/{x}.png`);
    } else if (value === "aerial") {
      tileLayer
        .getSource()
        .setUrl(`${bems_inc_Url}/tiles/aerial/{z}/{y}/{x}.jpeg`);
    }
  };

  // 인천시 경계
  const icOutBoundLayer = useMemo(() => {
    let markerStyle = new Style({
      stroke: new grade({
        color: "#42b4ec",
        width: 3,
      }),
    });
    let vectorLayer = new VectorLayer({
      source: new Vector({ wrapX: false }),
      style: markerStyle,
    });
    return vectorLayer;
  }, []);

  // 스포트 데이터레이어
  const spotLayer = useMemo(() => {
    let spotStyle = new Style({});
    let spotMarkerSource = new Vector();
    let spotMarkerLayer = new VectorLayer({
      source: spotMarkerSource,
      style: spotStyle,
    });

    return spotMarkerLayer;
  }, []);

  // 마커레이어
  const markerLayer = useMemo(() => {
    let markerStyle = new Style({
      image: new Icon({
        //마커 이미지
        opacity: 1, //투명도 1=100%
        scale: 0.1, //크기 1=100%
        src: pinsvg,
      }),
      //html의 css, z-index 기능이다.
      zindex: 10,
    });

    let markerSource = new Vector();
    let markerLayer = new VectorLayer({
      source: markerSource, //마커 feacture들
      style: markerStyle, //마커 스타일
    });
    return markerLayer;
  }, []);

  const updateMapLayers = () => {
    console.log(asconLastData);
    let pointStyle = new CircleStyle({
      radius: 9,
      fill: new Fill({
        color: "#5c8cdd",
      }),
    });

    // Check if asconLastData is a valid array
    if (!Array.isArray(asconLastData) || asconLastData.length === 0) {
      console.error("asconLastData is not a valid array.");
      return;
    }

    // Loop through asconLastData and create a feature for each entry
    asconLastData.forEach((data) => {
      let pos = [Number(data?.xpos), Number(data?.ypos)];

      const feat = new Feature({
        geometry: new Point(pos),
        name: data?.name,
      });

      feat.setStyle(
        new Style({
          image: pointStyle,
          text: new Text({
            text: " " + data?.name,
            scale: 1.3,
            textAlign: "center",
            offsetY: 20,
            fill: new Fill({
              color: "#000",
            }),
            backgroundFill: new Fill({
              color: "rgba(225,225,225, 0.6)",
            }),
          }),
          zIndex: -99,
        }),
      );

      spotLayer.getSource().addFeature(feat);
    });

    // Set the map center to the first data point
    let firstPos = [
      Number(asconLastData[0]?.xpos),
      Number(asconLastData[0]?.ypos),
    ];

    if (mapObject && mapObject.getView) {
      console.log("Setting mapObject center to:", firstPos);
      mapObject.getView().setCenter(firstPos);
    } else {
      console.error("Map object is not initialized.");
    }
  };

  // View(기본 위치값)
  const view = new View({
    projection: getProjection("EPSG:3857"),
    center: fromLonLat([126.654839, 37.453079]), //인천
    extent: [13982033, 4420002, 14120003, 4575085],
    zoom: 11.8,
  });
  let format = new WKT();
  let map = undefined;

  //   1. 지도 생성
  useEffect(() => {
    if (mapObject === null) {
      map = new OlMap({
        layers: [
          tileLayer,
          // hybridLayer,
          icOutBoundLayer, //인천 경계

          spotLayer,
          markerLayer,
        ],
        target: "map",
        view: view,
      });

      setMapObject(map);
      return () => {
        if (map !== null) {
          map.setTarget(null);
        }
      };
    }
  }, []);

  useEffect(() => {
    // icOutBound가 존재하고, geom이 정의된 경우에만 처리

    if (icOutBound && icOutBound.geom) {
      let feat1 = format.readFeature(icOutBound.geom);
      icOutBoundLayer.getSource().addFeature(feat1);
    } else {
      console.warn("icOutBound is not valid or geom is undefined");
    }
  }, [icOutBound]);

  //  2. Evt 만들어 지도 클릭시 클릭이벤트 지우고 생성
  useEffect(() => {
    if (!mapObject) return;

    const singleClickEvt = (evt) => {
      const feature = mapObject.forEachFeatureAtPixel(
        evt.pixel,
        function (feature) {
          return feature;
        },
      );
      // console.log(feature);
      if (!feature) return;

      markerLayer.getSource().clear();
      const xpos = feature.values_.geometry.flatCoordinates[0];
      const ypos = feature.values_.geometry.flatCoordinates[1];
      const name = feature.get("name");
      const index = feature.get("index");

      // 추출한 정보를 상위 컴포넌트로 전달
      onMapPointClick({ name, index });
      const markerFeature = new Feature({
        geometry: new Point([xpos, ypos]),
      });
      // console.log("click", feature);
      markerFeature.setStyle(
        new Style({
          image: new Icon({
            opacity: 1,
            scale: 0.1,
            src: pinsvg,
          }),
          zindex: 10,
        }),
      );
      markerLayer.getSource().addFeature(markerFeature);
      mapObject.getView().setCenter([xpos, ypos]);
    };
    mapObject.on("singleclick", singleClickEvt);

    return () => {
      mapObject.un("singleclick", singleClickEvt);
    };
  }, [mapObject]);

  useEffect(() => {
    // mapObject 초기화 코드 (예시로 작성)
    if (!mapObject) {
      console.error("Map is not initialized");
      return;
    }

    updateMapLayers();
  }, [asconLastData]);

  return (
    <div className="asconMapContainer">
      <div className="elevated">
        <ButtonGroup variant="outlined" aria-label="outlined button group">
          <Button
            value="base"
            className={
              props.showMapValue === enShowMap.ShowBase ? "click" : "basic"
            }
            onClick={() => {
              onClick("base");
              props.setShowMapValue(enShowMap.ShowBase);
            }}
          >
            기본
          </Button>
          <Button
            value="aerial"
            className={
              props.showMapValue === enShowMap.ShowStellite ? "click" : " basic"
            }
            onClick={() => {
              onClick("aerial");
              props.setShowMapValue(enShowMap.ShowStellite);
            }}
          >
            항공
          </Button>
        </ButtonGroup>

        {/* <ButtonGroup sx={{ paddingLeft: 1 }}>
          <Button onClick={props.toggleTextview}>
            {props.textview ? "측정소명 숨기기" : "측정소명 보이기"}
          </Button>
        </ButtonGroup> */}
      </div>
      <div className="map">
        <div id="map" value={mapObject}></div>
      </div>
    </div>
  );
}

export default AsconMap;
